module.exports = __webpack_public_path__ + "img/3-2.c6308a3e.png";